import {baseApi} from 'core/redux/store/api';
import {API_VERSION} from 'core/helpers/env';
import {transformErrorResponse} from 'core/redux/store/api/utils';
import {IBrandResponse, IBrandsListResponse, IBrandsProductsResponse} from 'modules/brands/models';
import {buildHeaders} from 'core/helpers/api/headers';

export const BRANDS_PATH = `${API_VERSION}/brands`;

/* eslint-disable sort-keys */
export const brandsApi = baseApi.injectEndpoints({
    overrideExisting: true,
    endpoints: (builder) => ({
        getBrandsList: builder.query<IBrandsListResponse, void | {isMainPage?: boolean}>({
            query: (args) => ({
                url: args?.isMainPage ? `${BRANDS_PATH}?isMainPage=true` : BRANDS_PATH,
                method: 'GET',
                headers: buildHeaders(!args?.isMainPage ? {withSeo: 'list'} : {}),
            }),
            transformErrorResponse,
        }),

        getBrandsProducts: builder.query<IBrandsProductsResponse, {code: string; page?: number}>({
            query: (query) => {
                const currentPage = query.page ? `&pageNumber=${query.page}` : '';

                return {
                    url: `${API_VERSION}/catalog/products/brand/${query.code}?pageSize=12${currentPage}`,
                    method: 'GET',
                };
            },
        }),

        getBrandX: builder.query<IBrandResponse, {code: string}>({
            query: ({code}) => ({
                url: `${BRANDS_PATH}/${code}`,
                method: 'GET',
                headers: buildHeaders({withSeo: 'detail'}),
            }),
        }),
    }),
});

export const {useGetBrandsListQuery, useGetBrandsProductsQuery, useGetBrandXQuery} = brandsApi;

export const {getBrandsList, getBrandsProducts, getBrandX} = brandsApi.endpoints;
